var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgoda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 243.443,
    height: 83.127,
    viewBox: "0 0 243.443 83.127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_913",
    "data-name": "Rectangle 913",
    width: 112,
    height: 58,
    transform: "translate(-0.06 0.038)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1009",
    "data-name": "Group 1009",
    transform: "translate(-553.897 -1057.818)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_275",
    "data-name": "Rectangle 275",
    width: 243.443,
    height: 83.127,
    rx: 8,
    transform: "translate(553.897 1057.818)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "agoda-integrations-logo",
    transform: "translate(620.06 1069.962)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2265",
    "data-name": "Path 2265",
    d: "M86.034,92.063a8.318,8.318,0,1,0,8.273,8.318A8.3,8.3,0,0,0,86.034,92.063Z",
    transform: "translate(-53.098 -51.154)",
    fill: "#fcb615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2266",
    "data-name": "Path 2266",
    d: "M51.165,92.063a8.318,8.318,0,1,0,8.272,8.318A8.3,8.3,0,0,0,51.165,92.063Z",
    transform: "translate(-41.348 -51.154)",
    fill: "#ed353f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2267",
    "data-name": "Path 2267",
    d: "M120.9,92.063a8.318,8.318,0,1,0,8.273,8.318A8.3,8.3,0,0,0,120.9,92.063Z",
    transform: "translate(-64.848 -51.154)",
    fill: "#02af56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2268",
    "data-name": "Path 2268",
    d: "M190.639,92.063a8.318,8.318,0,1,0,8.273,8.318A8.305,8.305,0,0,0,190.639,92.063Z",
    transform: "translate(-88.348 -51.154)",
    fill: "#00a8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2269",
    "data-name": "Path 2269",
    d: "M155.77,92.063a8.318,8.318,0,1,0,8.271,8.318A8.307,8.307,0,0,0,155.77,92.063Z",
    transform: "translate(-76.597 -51.154)",
    fill: "#a14699"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2270",
    "data-name": "Path 2270",
    d: "M57.426,51.7a6.787,6.787,0,1,0-6.787,6.825A6.657,6.657,0,0,0,57.426,51.7Zm-16.42,0a9.635,9.635,0,0,1,19.266-.037v8.292a1.373,1.373,0,0,1-1.459,1.43,1.354,1.354,0,0,1-1.459-1.43V57.534h-.147a7.533,7.533,0,0,1-6.75,3.633A9.355,9.355,0,0,1,41.006,51.7Z",
    transform: "translate(-40.712 -34.363)",
    fill: "#595a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2271",
    "data-name": "Path 2271",
    d: "M92.208,51.7a6.787,6.787,0,1,0-6.787,6.825A6.657,6.657,0,0,0,92.208,51.7Zm-12.7,15.593a1.373,1.373,0,0,1-.839-1.8,1.235,1.235,0,0,1,1.788-.771,11.127,11.127,0,0,0,4.706,1.064c4.342,0,6.969-2.606,6.969-7.045V57.531h-.147a7.533,7.533,0,0,1-6.75,3.633,9.47,9.47,0,1,1,9.817-9.5v6.9c0,5.944-3.795,9.942-10,9.942A12.7,12.7,0,0,1,79.509,67.293Z",
    transform: "translate(-52.433 -34.362)",
    fill: "#595a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2272",
    "data-name": "Path 2272",
    d: "M126.99,51.7a6.787,6.787,0,1,0-6.787,6.825A6.658,6.658,0,0,0,126.99,51.7Zm-16.418,0a9.635,9.635,0,1,1,9.633,9.466A9.42,9.42,0,0,1,110.572,51.7Z",
    transform: "translate(-64.155 -34.363)",
    fill: "#595a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2273",
    "data-name": "Path 2273",
    d: "M161.771,47.915a6.787,6.787,0,1,0-6.787,6.825A6.657,6.657,0,0,0,161.771,47.915Zm-16.418,0a9.356,9.356,0,0,1,9.451-9.466,7.533,7.533,0,0,1,6.75,3.633h.147V32.432A1.375,1.375,0,0,1,163.16,31a1.355,1.355,0,0,1,1.459,1.432V47.95a9.635,9.635,0,0,1-19.267-.035Z",
    transform: "translate(-75.875 -30.577)",
    fill: "#595a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2274",
    "data-name": "Path 2274",
    d: "M196.555,51.7a6.787,6.787,0,1,0-6.787,6.825A6.658,6.658,0,0,0,196.555,51.7Zm-16.42,0a9.635,9.635,0,0,1,19.266-.037v8.292a1.373,1.373,0,0,1-1.459,1.43,1.354,1.354,0,0,1-1.459-1.43V57.534h-.147a7.532,7.532,0,0,1-6.75,3.633A9.355,9.355,0,0,1,180.135,51.7Z",
    transform: "translate(-87.596 -34.363)",
    fill: "#595a5a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgoda);
export default __webpack_public_path__ + "static/media/agoda.19713f57956cc28c0d10607ffaeb85a2.svg";
export { ForwardRef as ReactComponent };